import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

export interface PhysicianAccreditationParameter extends Parameter{

    searchTerm: number;
    orderBy: string;
}

export interface PhysicianAccreditation {

    id?: number;
    accreditationNotes:string;
    date:Date;    
    accreditationId:any;   
    physicianId:any;    
     
    tenantId: any;
    branchId: any;
    
    parameters?: PhysicianAccreditationParameter[];
    links?: any;


}


export abstract class PhysicianAccreditationData { 

    abstract list(url: string): Observable<PhysicianAccreditation[]>;
    abstract create(url: string, data: PhysicianAccreditation[]): Observable<any>;
    abstract update(url: string, data: PhysicianAccreditation): Observable<any>;
    abstract delete(url: string): Observable<any>; 
   
}


